import { allAuditTypes } from 'json/new-to-old-audit'
export let filterLabels = [
  {
    label: '奖励类型',
    value: 'businessType',
    type: 'select',
    clearable: true,
    options: allAuditTypes
  },
  {
    label: '事业部归属',
    value: 'businessDepartmentId',
    type: 'select',
    clearable: true,
    options: [],
    props: {
      label: 'name',
      value: 'id'
    }
  },
  {
    label: '商品名称',
    value: 'goodsName',
    type: 'input',
    clearable: true
  },
  {
    label: '奖励金额',
    type: 'price-slot',
    minName: 'rewardMoneyMin',
    maxName: 'rewardMoneyMax',
    value: 'rewardMoney'
  },
  {
    label: '奖励时间',
    type: 'time-slot',
    startName: 'rewardDateStart',
    endName: 'rewardDateEnd',
    value: 'rewardDate'
  }
]
// 河北医护奖励的筛选类型
export let medicalRewardFilterLabels = [
  {
    label: '奖励金额',
    type: 'price-slot',
    minName: 'rewardMoneyMin',
    maxName: 'rewardMoneyMax',
    value: 'rewardMoney'
  },
  {
    label: '奖励时间',
    type: 'time-slot',
    startName: 'rewardDateStart',
    endName: 'rewardDateEnd',
    value: 'rewardDate'
  }
]
// 奖励汇总表头
export let allAuditLables = [
  {
    label: '奖励流水号',
    value: 'number',
    minWidth: 110
  },
  {
    label: '奖励类型',
    value: 'businessDescription',
    minWidth: 120
  },
  {
    label: '事业部归属',
    value: 'businessDepartmentName'
  },
  {
    label: '活动名称',
    value: 'promotionName'
  }
  // {
  //   label: '用户名',
  //   value: 'gainerName'
  // },
  // {
  //   label: '手机号',
  //   value: 'gainerMobile'
  // },
  // {
  //   label: '是否业务员',
  //   value: 'isSalesMan'
  // },
  // {
  //   label: '是否绑定CPS合同',
  //   value: 'isCpsBind'
  // }
]
// 奖励汇总表头
export let medicalRewardLables = [
  {
    label: '奖励流水号',
    value: 'number',
    minWidth: 110
  },
  {
    label: '奖励类型',
    value: 'businessDescription',
    minWidth: 120
  },
  {
    label: '事业部归属',
    value: 'businessDepartmentName',
    minWidth: '120'
  }
  // {
  //   label: '用户名',
  //   value: 'gainerName'
  // },
  // {
  //   label: '手机号',
  //   value: 'gainerMobile'
  // },
  // {
  //   label: '是否业务员',
  //   value: 'isSalesMan'
  // },
  // {
  //   label: '是否绑定CPS合同',
  //   value: 'isCpsBind'
  // }
]
